import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Import all translation JSON files
var req = require.context("./translations", true, /^(.*\.(json$))[^.]*$/);
let messages = {}
req.keys().forEach(function (key) {
  const name = key.replace(/^.*[\\\/]/, '').replace(/\.[^/.]+/, "")
  messages[name] = req(key)
});

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'nl', // set locale
  fallbackLocale: 'nl',
  messages, // set locale messages
})

export default i18n
